import {EstacaoChuva, Estrato, FaseLunar, Posicao} from "./enums";
import {Entidade} from "./Entidade";
import {Column, Entity, JoinTable, ManyToMany, ManyToOne, PrimaryGeneratedColumn} from "typeorm";
import {Campanha} from "./Campanha";
import {Local} from "./Local";
import {Projeto} from "./Projeto";
import {MetodoAmostragem} from "./MetodoAmostragem";
import {JoinColumn, OneToMany} from "typeorm/browser";
import {Jornada} from "./Jornada";
import {Especime} from "./Especime";

@Entity("monitoramento")
export class Monitoramento  extends Entidade{
  contagem?: number = 0

  @ManyToMany(() => MetodoAmostragem, {cascade: true})
  @JoinTable({
    name: 'monitoramento_metodoamostragem',
    joinColumn: {
      name: 'monitoramento_id',
      referencedColumnName: 'id',
    },
    inverseJoinColumn: {
      name: 'metodos_id',
      referencedColumnName: 'id',
    },
  })
  metodos?: MetodoAmostragem[]

  @ManyToOne(() => Jornada)
  @JoinColumn({name:"jornada_id"})
  jornada?: Jornada

  @ManyToOne(() => Projeto, {cascade: true})
  @JoinColumn({name:"projeto_id"})
  projeto?: Projeto
  @ManyToOne(() => Campanha, {cascade: true})
  @JoinColumn({name:"campanha_id"})
  campanha?: Campanha
  @ManyToOne(() => Local, {cascade: true})
  @JoinColumn({name:"local_id"})
  local?: Local
  @Column()
  estacao?: EstacaoChuva
  @Column()
  inicio?: Date
  @Column()
  obs?: string
  // @Column()
  // estacaoChuva?: EstacaoChuva
  @Column()
  faseLunar?: FaseLunar
  @Column()
  fim?: Date
  @Column()
  estrato?: Estrato

  @Column()
  nomeTransecto?: string
  @Column()
  nomePostoCaptura?: string
  @Column()
  distanciaPercorrida?: number
  @Column()
  qtdeArmadilhas?: number
  @Column()
  tamanhoMalha?: number
  @Column()
  qtdeLances?: number
  @Column()
  qtdePassadas?: number
  @Column()
  posicao?: Posicao
  @Column()
  numeroRede?: number
  @Column()
  comprimentoRede?: number
  @Column()
  alturaRede?: number
  @Column()
  numeroDisparos?: number

  @Column()
  agencia_sigla?: string

  @Column()
  qtdeParcelas: number

  @Column()
  nomeArmadilha: string





  @OneToMany(() => Especime, (especime) => especime.monitoramento)
  especimes?: Especime[]

  get metodosEGrupos(): string|undefined {
    return this.metodos?.map(m => "[" + m.nome +" - " + m.grupos.join(",") +"]").join(" ")
  }

  get metodosOrdenados(): MetodoAmostragem[]{
    return this.metodos?.sort((a,b) => a.nome.localeCompare(b.nome)) ?? []
  }


}
